export enum DocumentTemplateFilterOptions {
    None = 1,
    Deleted = 2
}
